import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService, ResponseResult } from 'tnx-shared';

@Injectable({
    providedIn: 'root',
})
export class EmailSenderService extends BaseService {
    entityName = 'EmailSender';
    serviceCode = 'notification';

    constructor(http: HttpClient, injector: Injector,
                private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
        this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    getEmailSenderSetting(): Promise<ResponseResult> {
        return this._http.get<ResponseResult>(`${this.serviceUri}/GetEmailSenderSetting`).toPromise();
    }

    saveEmailSetting(data: any): Promise<ResponseResult> {
        return this._http.post<ResponseResult>(`${this.serviceUri}/SaveEmailSenderSetting`, data).toPromise();
    }


    sendTestEmail(data: any): Promise<ResponseResult> {
        return this._http.post<ResponseResult>(`${this.serviceUri}/TestSendEmail`, data).toPromise();
    }
}
